import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./FinishStudy.module.less";
import { Skeleton } from "react-vant";
import { getMyLessonv3 } from "api/course";
import useScrollLoad from "utils/useScrollLoad";
const loadingText = {
  nomore: "已经到底啦～",
  loading: "正在加载～",
  empty: "暂无数据"
};
const FinishStudy = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [dataList, setDataList] = useState([]);
  const loadData = async () => {
    setIsLoading(true);
    const res = await getMyLessonv3(currentPage);
    setIsLoading(false);
    if (res.code === 200) {
      setTotalCount(res.data.total_count);
      setCurrentPage(currentPage + 1);
      if (Array.isArray(res.data?.data) && res.data?.data.length > 0) {
        setDataList([...dataList, ...res.data.data]);
      } else {
        setTotalCount(0);
      }
    }
  };
  const containerRef = useScrollLoad(() => {
    if (dataList.length < totalCount && !isLoading) {
      loadData();
    }
  });
  useEffect(() => {
    loadData();
  }, []);
  return (
    <div className={styles["finish-study-container"]} ref={containerRef}>
      {isLoading && dataList.length === 0 ? <Skeleton title /> : null}
      {!isLoading && dataList.length === 0 ? (
        <div className={styles["empty-block"]}>
          <div className={styles["empty-block-title"]}>
            {localStorage.getItem("access_token")
              ? "您还没有任何课程记录哦～"
              : "请登录以便获取更多信息"}
          </div>
          <div
            className={styles["empty-block-button"]}
            onClick={() => {
              if (localStorage.getItem("access_token")) {
                navigate("/main/textbook/0");
              } else {
                navigate("/login/logon");
              }
            }}
          >
            {localStorage.getItem("access_token") ? "立即选课" : "立即登录"}
          </div>
        </div>
      ) : null}
      {dataList.length > 0 ? (
        <>
          {dataList.map((item, index) => (
            <div
              className={styles["study-item"]}
              key={`finish-study-item-${index}`}
            >
              <div className={styles["study-item-top"]}>
                {item.lesson_id ? (
                  <span className={styles["study-item-top-id"]}>
                    {`ID：${item.lesson_id}`}
                  </span>
                ) : null}
                <span className={styles["study-item-top-time"]}>
                  {item.event_time || ""}
                </span>
              </div>
              <div className={styles["study-item-content"]}>
                <img className={styles["content-pic"]} src={item.cover} />
                <div className={styles["content-desc"]}>
                  <div className={styles["desc-series"]}>
                    {item.series_title || ""}
                  </div>
                  <div className={styles["desc-books"]}>
                    {item.books_title || ""}
                  </div>
                  <div className={styles["desc-grades"]}>
                    {item.grades_title || ""}
                  </div>
                  <div className={styles["desc-materials"]}>
                    {item.materials_title || ""}
                  </div>
                  <div className={styles["desc-buttons"]}>
                    <div
                      className={styles["desc-buttons-report"]}
                      onClick={() =>
                        navigate(`/studyReport?id=${item.lesson_id}`)
                      }
                    >
                      课程报告
                    </div>
                    <div
                      className={styles["desc-buttons-record"]}
                      onClick={() =>
                        navigate(
                          `/classroom/lesson/${item.lesson_id}`
                        )
                      }
                    >
                      课程回顾
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
          <div className={styles["bottom-text"]}>
            {isLoading && dataList.length === 0
              ? ""
              : isLoading
              ? loadingText["loading"]
              : dataList.length === 0
              ? loadingText["empty"]
              : loadingText["nomore"]}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default FinishStudy;
